import cx from 'clsx';
import { ArrowRightIcon } from '@heroicons/react/outline';
import { Icon } from '@vechaiui/react';
import { useNavigate } from 'react-router-dom';

import { PublicRoute } from '#/constants/page-route';

const SignUpButton: React.FC<SignUpButtonProps> = ({
  className,
  iconClassName,
  text,
  textClassName,
  route,
}) => {
  const navigate = useNavigate();

  return (
    <div>
      <button
        className={cx(
          'flex items-center justify-between px-5 py-4 mt-5 rounded-full w-72 hover:cursor-pointer',
          className,
        )}
        onClick={() => navigate(route)}
      >
        <div className={cx(textClassName)}>{text}</div>
        <Icon as={ArrowRightIcon} className={cx('w-5', iconClassName)} label="selector" />
      </button>
    </div>
  );
};
type SignUpButtonProps = {
  className: string;
  iconClassName: string;
  text: string;
  textClassName: string;
  route: PublicRoute;
};

export default SignUpButton;
